export const IS_LOCAL = process.env.NEXT_PUBLIC_CONNECTOR_BUILDER_LOCAL_MODE
export const PRODUCTION_PLATFORM_API_URI =
  process.env.NEXT_PUBLIC_PROD_ENGINE_API_URI ??
  process.env.NEXT_PUBLIC_ENGINE_API_URI
export const PLATFORM_API_URI = process.env.NEXT_PUBLIC_ENGINE_API_URI
export const PLATFORM_UI_URI = process.env.NEXT_PUBLIC_ENGINE_UI_URI
